import { CheckCircle } from "lucide-react";
import type React from "react";
import { useEffect, useState } from "react";
import Confetti from "react-confetti";
import { Link } from "react-router-dom";

const InviteAccepted: React.FC = () => {
	const [windowDimensions, setWindowDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight,
	});
	const [showConfetti, setShowConfetti] = useState(true);

	useEffect(() => {
		const handleResize = () => {
			setWindowDimensions({
				width: window.innerWidth,
				height: window.innerHeight,
			});
		};

		window.addEventListener("resize", handleResize);

		const timer = setTimeout(() => setShowConfetti(false), 5000);

		return () => {
			window.removeEventListener("resize", handleResize);
			clearTimeout(timer);
		};
	}, []);

	return (
		<div className="min-h-screen bg-gradient-to-br from-pink-50 via-orange-50 to-yellow-50 flex items-center justify-center">
			{showConfetti && (
				<Confetti
					width={windowDimensions.width}
					height={windowDimensions.height}
					recycle={false}
					numberOfPieces={200}
					gravity={0.1}
				/>
			)}

			<div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
				<div className="max-w-md mx-auto">
					<div className="bg-white/80 backdrop-blur-sm rounded-lg shadow-sm border border-gray-200 p-6 sm:p-8 text-center">
						<CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-6" />

						<h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">Invite accepted!</h1>

						<p className="text-gray-600 text-sm sm:text-base mb-8">
							You've successfully joined the team. Sign in to get started.
						</p>

						<Link
							to="/"
							className="inline-block w-full bg-gradient-to-r from-orange-400 to-pink-400 hover:from-orange-500 hover:to-pink-500 text-white font-semibold py-4 px-6 rounded-lg transition-all duration-300 shadow-sm text-base touch-manipulation min-h-[56px] leading-8"
						>
							Go to dashboard
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default InviteAccepted;
